import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { readEndpoint } from 'redux-json-api';

import AppBar from '@material-ui/core/AppBar';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Toolbar from '@material-ui/core/Toolbar';

import common from '@material-ui/core/es/colors/common';
import grey from '@material-ui/core/es/colors/grey';
import { withStyles } from '@material-ui/styles';

import CompanyRow from './CompanyRow';

import { selectActiveCompanies, selectInactiveCompanies } from './selectors';


class CompanyList extends Component {
  static propTypes = {
    // state props
    activeCompanies: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string.isRequired,
    })).isRequired,
    inactiveCompanies: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string.isRequired,
    })).isRequired,

    // dispatch props
    readEndpoint: PropTypes.func.isRequired,
  };

  state = {
    loading: true,
    showInactive: false,
  };

  componentDidMount() {
    const { showInactive } = this.state;

    this.getCompanies(showInactive);
  }

  getCompanies(showInactive) {
    const { readEndpoint } = this.props;

    this.setState({ loading: true, showInactive });

    /**
     * Read active or inactive companies, and include the currently active
     * subcontractor as JSONAPI compound document.
     */
    const endpoint = `company?filter[is-active__exact]=${showInactive ? 'False' : 'True'}` +
      '&filter[deleted-at__isnull]=True' +
      '&include=active_subcontractor';

    readEndpoint(endpoint)
      .catch((error) => {
        console.error(`[TVV] Company.List.getCompanies(showInactive=${showInactive}) error=${error}`);
      })
      .finally(() => this.setState({ loading: false }));
  }

  handleToggle() {
    const { showInactive } = this.state;

    this.getCompanies(!showInactive);
  }

  render() {
    const { activeCompanies, classes, inactiveCompanies } = this.props;
    const { loading, showInactive } = this.state;

    const companies = showInactive ? inactiveCompanies : activeCompanies;

    return (
      <Fragment>
        <AppBar position="relative">
          <Toolbar variant="dense" className={classes.appBar}>
            <FormControlLabel
              classes={{ label: classes.toggleLabel }}
              control={
                <Switch
                  color="primary"
                  checked={showInactive}
                  onChange={() => this.handleToggle()}
                />
              }
              label="Inactief"
            />
          </Toolbar>
        </AppBar>

        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>
                Naam
                <br />
                <em>Actieve<br />onderaannemer</em>
              </TableCell>

              <TableCell>Adres</TableCell>
              <TableCell>Contact</TableCell>
              <TableCell />
            </TableRow>
          </TableHead>

          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={6}>Bezig met laden...</TableCell>
              </TableRow>
            ) : companies.map(company => <CompanyRow key={`company-${company.id}`} company={company} />)}
          </TableBody>
        </Table>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  activeCompanies: selectActiveCompanies(state),
  inactiveCompanies: selectInactiveCompanies(state),
});

export default connect(mapStateToProps, { readEndpoint })(withStyles({
  appBar: {
    backgroundColor: grey[300],
  },
  toggleLabel: {
    color: common.black,
    opacity: 0.38,
    transition: 'opacity 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
  },
})(CompanyList));
